<template>
	<div v-if="playlist_url">
		<k-panel class="elevation-1">
			<template #title>Live</template>

			<template #default>
				<k-video-player
					v-if="playlist_url"
					:url="playlist_url"
					:hide-bar="false"
					:volume="1.0"
					v-on:position-duration="position_duration"
					ref="player"
				></k-video-player>
				<div v-if="!playlist_url">Cannot load video</div>
			</template>

			<template #footer>
				<k-btn @click="take_clip(60)" size="m" color="primary"> Clip </k-btn>
				<k-dialog offset-y :close-on-content-click="false" :nudge-width="150" v-model="tag_dialog" :transition="false">
					<template #activator>
						<k-btn size="m" color="success" slot="activator" @click="tag_dialog = !tag_dialog">Add tag</k-btn>
					</template>
					<div v-if="tag_dialog" class="ks-floating-menu">
						<tag-editor :event_uuid="uuid" :position="position" v-on:save="tag_dialog=false" @close="tag_dialog=false"></tag-editor>
					</div>
				</k-dialog>
			</template>
		</k-panel>
	</div>
</template>

<script>
import TagEditor from '../events/tags/Editor.vue';

export default {
	props: ["uuid"],
	components: {
		TagEditor
	},
	data () {
		var config_ch = this.$cloudserver.channel("events:clip_settings:"+this.uuid);
		return {
			ws_channel: config_ch,
			playlist_url: undefined,
			position: undefined,
			duration: undefined,
			tag_dialog: false
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				this.playlist_url = newVal.live_playlist_url;
			},
			deep: true
		}
	},
	created () {
		this.ws_channel.join();
	},
	methods: {
		position_duration(value) {
			this.position = value.position;
			this.duration = value.duration;
		},
		take_clip(clip_length) {
			this.$emit("clip", {duration: this.duration, position: this.position, length: clip_length});
		}
	}

}
</script>